import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import DashboardLayout from "../../layouts/DashboardLayout";
import OrganizationsPage from "./organizations/OrganizationsPage";
import PlatformSubscriptionsPage from "./subscriptions/PlatformSubscriptionsPage";
import PlansPage from "./plans/PlansPage";
import UsersPage from "../users/UsersPage";
import SecurityPage from "../account/SecurityPage";

// Later you will replace these with real components
// import PlatformOverview from "./PlatformOverview";
// import UsersPage from "./UsersPage";
// etc.

const PlatformDashboard = () => {
  const [searchParams] = useSearchParams();
  const querySection = searchParams.get("section");
  const [activeSection, setActiveSection] = useState(
    querySection || "dashboard",
  );

  const renderContent = () => {
    switch (activeSection) {
      case "dashboard":
        return (
          <div className="dashboard-overview">
            <h2>Platform Dashboard</h2>
            <p>Welcome, Platform Owner</p>

            <div className="stats-grid">
              <div className="stat-card">
                <h3>Total Organizations</h3>
                <p className="stat-value">48</p>
              </div>
              <div className="stat-card">
                <h3>Active Users</h3>
                <p className="stat-value">1,284</p>
              </div>
              <div className="stat-card">
                <h3>Monthly Revenue</h3>
                <p className="stat-value">৳ 4,82,000</p>
              </div>
              <div className="stat-card">
                <h3>Pending Approvals</h3>
                <p className="stat-value">7</p>
              </div>
            </div>
          </div>
        );

      case "organizations":
        return <OrganizationsPage />;

      case "users":
        return <UsersPage />;

      case "analytics":
        return (
          <div>
            <h2>Analytics</h2>
            <p>Platform-wide analytics and insights</p>
          </div>
        );

      case "subscriptions":
        return <PlatformSubscriptionsPage />;

      case "plans":
        return <PlansPage />;

      case "settings":
        return (
          <div>
            <h2>Platform Settings</h2>
            <p>Global platform settings</p>
          </div>
        );

      case "security":
        return <SecurityPage />;

      default:
        return <div>Section not found</div>;
    }
  };

  return (
    <DashboardLayout
      activeSection={activeSection}
      onSectionChange={setActiveSection}
    >
      {renderContent()}
    </DashboardLayout>
  );
};

export default PlatformDashboard;